import React from 'react';
import { Tag } from 'antd';
import { LockOutlined } from '@ant-design/icons';

const NoAccessTag = (props) => (
  <Tag icon={<LockOutlined />} color="error" {...props}>
    No access
  </Tag>
);

export default NoAccessTag;
